// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import clientReducer from './reducers/clientReducer';
import vendorReducer from './reducers/vendorReducer';
import projectReducer from './reducers/projectReducer';
import fundReducer from './reducers/fundsReducer';
const store = configureStore({
  reducer: {
    clients: clientReducer,
    Centers: vendorReducer,
    projects: projectReducer,
    funds: fundReducer
    
  },
});

export default store;